import { useEffect, useRef, useState } from "react";
import { Form, Table } from "react-bootstrap";
import styled from "styled-components";
import Loading from "./Loading";

const Wrap = styled.div`
    overflow: auto;
    &::-webkit-scrollbar {
        width: 0.6125rem;
        height: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(189, 197, 209, 0.6);
    }

    th {
        background-color: #f8fafd;
        font-size: 14px !important;

        &.sort {
            cursor: pointer;
            &::after {
                content: "";
                display: inline-block;
                width: 11px;
                height: 11px;
                vertical-align: middle;
                margin-left: 5px;
                background-image: url("${process.env.PUBLIC_URL}/image/icn_table_sort.svg");
            }
            &.desc {
                &::after {
                    background-image: url("${process.env.PUBLIC_URL}/image/icn_table_sort_desc.svg");
                    transform: rotate(180deg);
                }
            }
            &.asc {
                &::after {
                    background-image: url("${process.env.PUBLIC_URL}/image/icn_table_sort_desc.svg");
                }
            }
        }

    }
    th,
    td {
        text-align: center;
        vertical-align: middle;
    }

    .Loading {
        > div {
            min-height: 150px;
        }
    }
`;
function DataTable({data={head: [], body: [], total: 0}, useNo=false, sort=[], activeSortIdx, activeSortType="desc", isError, page, perPage,  isLoading, handleClickSort=()=>{}, ...props}) {
    const [sortIdx, setSortIdx] = useState(activeSortIdx);
    const [sortType, setSortType] = useState(activeSortType);
    const colspan = (useNo || props.useCheckbox) ?  (useNo && props.useCheckbox) ? data.head.length + 2 : data.head.length + 1 : data.head.length;

    const checkboxRefs = useRef([]);
    const checkAllRef = useRef();

    const setCheckboxVal = () => {
        const arr = [];
        checkboxRefs.current.forEach((el) => {
            if (el.checked) {
                arr.push(el.getAttribute("data-value"));
            }
        })

        props.setCheckboxVal(arr);
    }

    useEffect(() => {
        if (checkAllRef.current) {
            checkAllRef.current.checked = false;
        }
    },[data]);

    return (
        <Wrap {...props}>
            <Table hover>
                <thead>
                    <tr>
                        {
                            props.useCheckbox &&
                            <th>
                                <Form.Check ref={checkAllRef} onChange={(e) => {
                                    checkboxRefs.current.map((el) => {
                                        if (el.disabled != true) {
                                            el.checked = e.target.checked;
                                        }
                                    })
                                    setCheckboxVal();
                                }}/>
                            </th>
                        }
                        {
                        useNo &&
                        <th>No</th>
                        }
                        {data.head.map((v, i) => {
                            const useSort = sort.find((num) => {
                                return i == num
                            });
                            return (
                                <th key={i} className={useSort != undefined ? "sort " + (i == sortIdx ? sortType : "") : ""}
                                onClick={() => {
                                    if (useSort != undefined) {
                                        let result = "";
                                        if (sortIdx != i) {
                                            result = "desc";
                                        } else {
                                            result = sortType == "desc" ? "asc" : "desc"
                                        }
                                        setSortType(result);
                                        setSortIdx(i);
                                        handleClickSort(i, result);
                                    }
                                }}>
                                {v}
                            </th>);
                        })}
                    </tr>
                </thead>
                <tbody>
                    {
                    isLoading ?
                    <tr className="text-center">
                        <td colSpan={colspan}>
                            <Loading />
                        </td>
                    </tr>
                    :
                    isError ?
                        <tr className="text-center">
                            <td colSpan={colspan}>데이터를 불러오는 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.</td>
                        </tr>
                        :
                        !data.body || data.body.length == 0 ? (
                            <tr className="text-center">
                                <td colSpan={colspan}>
                                    {
                                        props.emptyDataMsg ? props.emptyDataMsg : "데이터가 없습니다."
                                    }
                                </td>
                            </tr>
                        ) : (
                            data.body.length > 0 && (
                                data.body.map((v, i) => {
                                    if (i == 0) {
                                        checkboxRefs.current = [];
                                    }
                                    return (
                                        <tr key={i}>
                                            {
                                                props.useCheckbox &&
                                                <td>
                                                    <Form.Check 
                                                        data-value={v[0].value} 
                                                        disabled={v[0].disabled} 
                                                        ref={(el) => {
                                                            if (el) {
                                                                checkboxRefs.current.push(el)
                                                            }
                                                        }}
                                                        onChange={(e) => {
                                                            if (!e.target.checked) {
                                                                checkAllRef.current.checked = false;
                                                            } else {
                                                                let checkedAll = true;
                                                                checkboxRefs.current.map(el => {
                                                                    if (!el.checked && !el.disabled) {
                                                                        checkedAll = false;
                                                                    }
                                                                });
                                                                if (checkedAll) {
                                                                    checkAllRef.current.checked = true;
                                                                }
                                                            }
                                                            setCheckboxVal();
                                                        }} 
                                                    />
                                                </td>
                                            }
                                            {
                                                useNo && 
                                                <td>{sortType == "desc" ? data.total - (page - 1) * perPage - i : (page - 1) * perPage + i + 1}</td>
                                            }
                                            {Object.values(v).map((v, i) => {
                                                if (props.useCheckbox) {
                                                    if (i != 0) {
                                                        return <td key={`td${i}`}>{v}</td>;
                                                    }
                                                } else {
                                                    return <td key={`td${i}`}>{v}</td>;
                                                }
                                            })}
                                        </tr>
                                    );
                                })
                            )
                        )
                    }
                </tbody>
            </Table>
        </Wrap>
    );
}

export default DataTable;